import styled, { css } from "styled-components";
import { fonts } from "assets/fontStyles";
import colours from "assets/colours";
import { Link } from "@reach/router";

const link = css`
  ${fonts.link}
  font-size: inherit;
  cursor: pointer;

  ${({ weight }) =>
    weight &&
    css`
      font-weight: ${weight};
    `}

  ${({ variant }) =>
    colours[variant] &&
    css`
      color: ${colours[variant]};
    `}
`;

const RouterLink = styled(Link)`
  ${link}
`;

const HtmlLink = styled.a`
  ${link}
`;

export { RouterLink, HtmlLink };
